import { type RouteObject } from "react-router-dom"

import PWALayout from "@components/layout/PWA.layout"
import { PrivacyPolicy } from "@pages/Legal/PrivacyPolicy"
import TermsAndConds from "@pages/Legal/TermsAndConds"
import HomePage from "@pages/Home.page"

export const PWARouter: RouteObject[] = [
  {
    path: "/",
    element: <PWALayout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "/privacy-policy",
        element: (
          <div className="bg-white p-4 rounded-lg mx-auto max-w-2xl pt-4 w-screen h-full flex items-center">
            <PrivacyPolicy />
          </div>
        ),
      },
      {
        path: "/terms-and-conditions",
        element: (
          <div className="bg-white p-4 rounded-lg mx-auto max-w-2xl pt-4 w-screen h-full flex items-center">
            <TermsAndConds />
          </div>
        ),
      },
    ],
  },
]
